// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../eachWeekendOfYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var eachWeekendOfYear = convertToFP(fn, 1);
export default eachWeekendOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/eachWeekendOfYear/index.js
// module id = 855
// module chunks = 0